@if (text) {
  <p [innerHTML]="text"></p>
}
@if (!text) {
  <p><ng-content></ng-content></p>
}
